import { paginatedTransform, rawTransform } from 'src/services/skuit/utils'
import { Batch, PaginatedResponse } from 'src/api/models'

import { API, CustomAxiosConfig } from './types'

export class BatchesAPI {
  api: API

  constructor(api: API) {
    this.api = api
  }

  retrieve = async (slug: string, config: CustomAxiosConfig = {}): Promise<Batch> => {
    const response = await this.api.get(`/logistics/batches/${slug}`, config)
    return rawTransform(Batch)(response.data)
  }

  list = async (config: CustomAxiosConfig = {}): Promise<PaginatedResponse<Batch>> => {
    const response = await this.api.get('/logistics/batches', config)
    return paginatedTransform(Batch)(response.data)
  }

  create = async (data: any, config: CustomAxiosConfig = {}): Promise<Batch> => {
    const response = await this.api.post('/logistics/batches', data, config)
    return rawTransform(Batch)(response.data)
  }

  patch = async (slug: string, data: any, config: CustomAxiosConfig = {}): Promise<Batch> => {
    const response = await this.api.patch(`/logistics/batches/${slug}`, data, config)
    return rawTransform(Batch)(response.data)
  }
}
